import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { APP_RELEASE } from '../../../views/app/AppDownload/appRelease';
import './style.css';

const DownloadBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="download-banner-container">
      <div className="container">
        <div className="download-banner-inner">
          <div>
            <h2>{t('download-banner.text')}</h2>
            <p>{t('download-banner.subtitle')}</p>
          </div>
          <div className="download-banner-actions">
            <Link to="/app" className="download-banner-cta">
              {t('download-banner.cta')}
            </Link>
            <a className="download-banner-direct" href={APP_RELEASE.href} download={APP_RELEASE.fileName}>
              {t('download-banner.direct')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadBanner;
